export const schema = {
  site_title: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      maximum: 300,
      minimum: 5,
    },
  },
};
